import { useSyncExternalStore } from 'react'

import { SIGNUP_PHONE_STEP_JUST_SEEN_KEY } from './index'

const noop = () => undefined
const subscribe = () => noop

function getSnapshot(): boolean {
  try {
    return window.sessionStorage.getItem(SIGNUP_PHONE_STEP_JUST_SEEN_KEY) === '1'
  } catch {
    return false
  }
}

const getServerSnapshot = (): boolean => false

export function useSignupPhoneStepJustSeen(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
